import { provideDefaultSharedDomainConfig } from '@praceprofirmy/shared-domain';
import { environment } from '../../environments/environment';

export const sharedDomainProviders = [
  provideDefaultSharedDomainConfig({
    appName: 'JP Design CRM',
    apiBaseUrl: environment.apiUrl,
  }),
];
